import type React from 'react';
import { useCallback, useLayoutEffect, useRef } from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import ConfirmationModal from '../components/ConfirmationModal';
import { UIActions } from '../ui/uiSlice';

const useConfirmPromise = ({ onClose }: { onClose?: () => void } = {}) => {
  const onCloseRef = useRef(onClose);
  useLayoutEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  const dispatch = useAppDispatch();

  return useCallback(
    <T>(
      perform: () => Promise<T>,
      title: string,
      message?: React.ReactNode,
    ): Promise<T> =>
      new Promise((resolve, reject) => {
        dispatch(
          UIActions.openModal(ConfirmationModal, {
            title,
            message,
            close: () => {
              onCloseRef.current?.();
              dispatch(UIActions.closeModal());
            },
            onConfirm: () => perform().then(resolve).catch(reject),
          }),
        );
      }),
    [dispatch],
  );
};

export default useConfirmPromise;
